<div class="list-container">
  <nb-card class="list-filter-card">
    <nb-card-body>
      <div class="list-filter">
        <div class="list-filter-title">
          <nb-icon pack="fas" icon="user"></nb-icon>
          Mitarbeiterstatistik
        </div>
        @if (form) {
          <form [formGroup]="form">
            <div class="list-filter-control no-print">
              <div class="filter-control-group">
                <label class="label" for="technician">Techniker*in</label>
                <wr-user-multi-select id="technician" formControlName="technicianReferences"
                                      [showNoneOption]="true"></wr-user-multi-select>
              </div>
              <div class="filter-control-group">
                <label class="label" for="datePicker">Zeitraum</label>
                <wr-date-range-picker id="datePicker" formControlName="selectedRange"
                                      [showTodayButton]="true"></wr-date-range-picker>
              </div>
              <button nbButton ghost status="primary" (click)="triggerFilter()">
                <nb-icon pack="eva" icon="search-outline"></nb-icon>
              </button>
              <button class="with-label-icon" nbButton ghost status="primary" (click)="printPage()" title="Drucken / PDF">
                <nb-icon pack="fas" icon="print"></nb-icon>
                Drucken
              </button>
            </div>
          </form>
          <div class="print-only print-filter-summary">
            <span><strong>Techniker:</strong> {{ technicianSummary() }}</span>
            <span><strong>Zeitraum:</strong> {{ timeframeSummary() }}</span>
          </div>
        }
      </div>
    </nb-card-body>
  </nb-card>
</div>
<div class="statistics-container">
  @for (cfg of chartCards(); track cfg.stack) {
    <nb-card [nbSpinner]="isLoading()">
      <nb-card-body>
        @if (statistics() !== undefined) {
          <div class="chart-actions no-print">
            <button class="with-label-icon" nbButton ghost status="primary" size="small"
                    (click)="exportCsv(cfg.csvName, cfg.csvHeader, cfg.data)">
              <nb-icon pack="fas" icon="file-csv"></nb-icon>
              Export CSV
            </button>
          </div>
          <wr-chart
            [labels]="labels()"
            [showValueLabels]="true"
            [title]="cfg.title">
            <wr-dataset
              type="bar"
              [data]="cfg.data"
              [label]="cfg.datasetLabel"
              [backgroundColor]="cfg.color"
              yAxisID="y"
              [stack]="cfg.stack">
            </wr-dataset>
          </wr-chart>
        }
      </nb-card-body>
    </nb-card>
  }
</div>
